export let thursdayUppercase = "Gu9ZPb";
export default {thursdayUppercase};